import "./LeafRadioMenu.scss";

type Option = {
  id: string;
  text: string;
};

export type Props = {
  options: Option[];
  onSelected: (id: string) => void;
  selectedId: string;
};

const LeafRadioMenu = (props: Props) => {
  const { options, onSelected, selectedId } = props;

  return (
    <div className="leaf-radio-menu">
      {options.map((option) => (
        <div key={option.id} className="leaf-radio-menu__item">
          <input
            type="radio"
            id={option.id}
            data-testid={option.id}
            name="export-option"
            value={option.id}
            checked={selectedId === option.id}
            onChange={() => onSelected(option.id)}
            className="leaf-radio-menu__input"
            aria-label={option.text}
          />
          <label htmlFor={option.id} className={`leaf-radio-menu__label ${selectedId === option.id ? "selected" : ""}`}>
            <span className="leaf-radio-menu__radio-circle" />
            <span className="leaf-radio-menu__text">{option.text}</span>
          </label>
        </div>
      ))}
    </div>
  );
};

export default LeafRadioMenu;
